
  import ImageHeader from '@/components/core/ImageHeader';
  import tableLoading from '@/components/tableLoading';
  import NoContent from '@/components/customer-content/NoContent'
  import CouponSlick from '@/components/CouponSection/CouponSlick'
  import Coupon from '@/components/CouponSection/Coupon'
  import HowItWorks from '@/components/how-it-works/HowItWorks'
  import ActivityCard from "@/components/ActivityCard.vue";

  export default {
    scrollToTop: true,
    components: {
      ImageHeader,
      tableLoading,
      NoContent,
      CouponSlick,
      Coupon,
      HowItWorks,
      ActivityCard
    },
    head() {
      return {
        title: this.title,
        meta: [{
            hid: 'description',
            name: 'description',
            content: this.description
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'activities in goa, water activities in goa, goa sightseeing, casino in goa, best casino in goa, water sports, south goa sightseeing, north goa sightseeing, casino in goa'
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.title
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.description
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: this.description
          },
          { hid: 'og:image:alt',
            property: 'og:image:alt',
            content: this.title ? this.title : 'Goa App'
          },
          { hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
          },
          { hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
          },
          { hid: 'twitter-image',
            property: 'twitter:image',
            content: this.$config.siteUrl + '/img/meta-imgs/activities-meta-image.webp'
          },

        ],
      }
    },
    scrollToTop: true,
    data() {
      return {
        title: 'Activities in Goa: Book Now & Get Upto 50% Off | Water Activities',
        description: 'Check Top Activities in Goa with Upto 50% Off: Scuba diving, Parasailing, Sunset Cruise, Sightseeing, Dudhsagar Falls, Casino Nightlife and more. Book Now!',
        schemaData: [],
        thingsToDo: null,
        tabSelected: 0,
        recentlyViewed: null,
        allHomeActivitiesData: null,
        homeactLoading: true,
        actLoading: true,
        allActivitiesData: null,
        eventCategoryModal: false,
        featuredCats: null,
        featuredCatsLoading: true,
        interLinks: {
        "title": "Explore More On Goa App",
        "links": [
          {"sub_title":"Book Activities In Goa",
          "interLinks":[
          {
            "name":"Water Sports In Goa",
            "url":"/goa/activities/category/water-sports"
          },
	        {
            "name":"Sightseeing In Goa",
            "url":"/goa/activities/category/sightseeing-tours"
          },
          {
            "name":"Cruise In Goa",
            "url":"/goa/activities/category/boat-parties"
          },
          {
            "name":"Casinos In Goa",
            "url":"/goa/activities/category/casino"
          },
          {
            "name":"Tours In Goa",
            "url":"/goa/activities/category/guided-tours-and-trails"
          },
          {
            "name":"Adventures In Goa",
            "url":"/goa/activities/category/adventure-sports"
          },
          {
            "name":"Hiking In Goa",
            "url":"/goa/activities/category/treks-and-hikes"
          },
          {
            "name":"Celebrations In Goa",
            "url":"/goa/activities/category/special-moments"
          },
          {
            "name":"Photoshoot In Goa",
            "url":"/goa/activities/category/photography"
          },

          ]},
          {"sub_title":"Goa Activities Booking",
          "interLinks":[{
            "name":"Romantic Dinner Cruise In Goa",
            "url":"/activities/romantic-dinner-cruise"
          },
          {
            "name":"Big Daddy Casino",
            "url":"/activities/big-daddy-casino-tickets"
          },
          {
            "name":"Goa Boat Party",
            "url":"/activities/party-boat-adventure"
          },
          {
            "name":"Water Sports In Goa",
            "url":"/activities/adventure-party-boat-with-water-sports"
          },
          {
            "name":"Goa Sightseeing Package By Bus",
            "url":"/activities/goa-darshan-bus"
          },
          {
            "name":"Paradise Cruise",
            "url":"/activities/evening-cruise-party-in-goa"
          },
           {
            "name":"North Goa Places To Visit",
            "url":"/activities/north-goa-sightseeing-tour"
          },
           {
            "name":"South Goa Places To Visit",
            "url":"/activities/south-goa-sightseeing-tour-car"
          },
          ]},
          
          {"sub_title":"Goa Activities Package",
          "interLinks":[{
            "name":"Grande Island Goa Scuba Diving",
            "url":"/activities/scuba-diving-at-grande-island-and-water-sports-combo"
          },
          {
            "name":"Scuba Diving In Goa",
            "url":"/activities/scuba-diving-goa-premium"
          },
          {
            "name":"Dudhsagar Waterfall Tour By Private Car",
            "url":"/activities/dudhsagar-waterfall-tour-by-private-car"
          },
          {
            "name":"Luxury Dinner Cruise In Goa",
            "url":"/activities/luxury-dinner-cruise-in-goa"
          },
          {
            "name":"Houses Of Goa",
            "url":"/activities/houses-of-goa-chandor"
          },
          {
            "name":"Cave Beach In Goa",
            "url":"/activities/cliff-cave-beach-trek-north-goa"
          },
           {
            "name":"Ballon Ring Decoration",
            "url":"/activities/beachside-balloon-ring-at-baga-beach"
          },
           {
            "name":"Candle Light Dinner",
            "url":"/activities/candle-light-dinner-at-calangute-beach"
          },
          ]},
          

          {"sub_title":"More on Goa App",
          "interLinks":[{
            "name":"Hire a Taxi",
            "url":"/taxi"
          },
          {
            "name":"Rent a Car",
            "url":"/rentals"
          },
          {
            "name":"Activities in Goa",
            "url":"activities"
          },

          {
            "name":"Holiday Packages",
            "url":"/packages"
          },

          ]}
        ]
      }
      };
    },
    jsonld() {
      if (!this.schemaData) {
        return null
      }
      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: this.schemaData.map((itm, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
            "url": `https://www.goa.app/activities/${itm.slug}`,
            "description": itm.post && itm.post.description ? itm.post.description :
              'activities in goa, water activities in goa, adventure activities in goa, sports activities in goa, water sports activities in goa, beach activities in goa, water sport activities in goa',
            "image": itm.post && itm.post.gallery && itm.post.gallery.length > 0 ? itm.post.gallery : [],
            "brand": {
              "@type": "Brand",
              "name": "Goa App",
              "url": "https://goa.app/"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "worstRating": "1",
              "ratingCount": "340",
              "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '4.7',
              "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : '5',
            },
            "offers": {
              "@type": "Offer",
              "url": `https://www.goa.app/activities/${itm.slug}`,
              "price": itm.seller ? this.activityDiscountPrice(itm.seller) : 0,
              "priceCurrency": "INR",
              "priceValidUntil": "2025-12-31",
              "availability": "InStock",
              "seller": {
                "@type": "Organization",
                "name": "Goa App"
              },
              "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "IN",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 10,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/FreeReturn"
              },
              "shippingDetails": {
                "@type": "OfferShippingDetails",
                "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "businessDays": {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": [
                      "https://schema.org/Monday",
                      "https://schema.org/Tuesday",
                      "https://schema.org/Wednesday",
                      "https://schema.org/Thursday",
                      "https://schema.org/Friday"
                    ]
                  },
                  "cutoffTime": "12:00:15Z",
                  "handlingTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 1,
                    "maxValue": 2,
                    "unitCode": "d"
                  },
                  "transitTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 1,
                    "maxValue": 10,
                    "unitCode": "d"
                  }
                },
                "shippingRate": {
                  "@type": "MonetaryAmount",
                  "value": "0",
                  "currency": "INR"
                },
                "shippingDestination": [{
                  "@type": "DefinedRegion",
                  "addressCountry": "IN",
                  "addressRegion": ["GA"]
                }]
              }
            },
          }
        })),
      };
    },

    mounted() {
      document.body.classList.add('modalOverflow');

      this.getHomeActitvitesData();
      this.getActitvitesData();
      this.getActitvitesCategoriesData();

      if (localStorage.getItem('recentlyViewed')) {
        this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
      }

      if (localStorage.getItem('activitiesFilter')) {
        localStorage.removeItem('activitiesFilter');
      }
      this.$parent.$emit("sentInterLinks", this.interLinks);
    },

    destroyed() {
      document.body.classList.remove('modalOverflow')
      if (document.getElementById('filterClose'))
        document.getElementById('filterClose').click();
    },

    methods: {
      async getHomeActitvitesData() {
        this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
          '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
        this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
        this.homeactLoading = false;
        this.$nextTick(() => {
          if (this.allHomeActivitiesData) {
            var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
              key].data]);
            schemaResult = schemaResult.flat(2);
            this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
          }
        })
        //this.changeThingsToDo(0)
      },

      async getActitvitesData() {
        this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
          res
          .text());
        this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
        this.actLoading = false;
        // this.$nextTick(() => {
        //   if (this.allHomeActivitiesData) {
        //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
        //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
        //   }
        // })
      },

      async getActitvitesCategoriesData() {
        this.featuredCatsLoading = true;
        this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
          res
          .text());
        this.featuredCats = this.getCryptKey(this.featuredCats);
        this.featuredCatsLoading = false;
      },

      changeThingsToDo(id) {
        switch (id) {
          case 0:
            this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
            break;
          case 1:
            this.thingsToDo = this.allHomeActivitiesData.photography;
            break;
          case 2:
            this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
            break;
          case 3:
            this.thingsToDo = this.allHomeActivitiesData.specialMoments;
            break;
          case 4:
            this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
            break;
          default:
            this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
        }
      },

      activitiesImage(image) {
        if (image.length > 0) {
          return image[0];
        } else {
          return '';
        }
      },

      // To add a fallback placeholder image if not rendereds from API
      setFallbackImageUrl(event) {
        event.target.src = require(`@/assets/img/placeholders/places.svg`)
      },

      activityDiscountPrice(seller) {
        if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
          .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
          return seller[0].tickets[0].prices[0].price
        }
        return 0
      },

      categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

    }
  }
